import React from 'react';
import styles from './TimeEntityConfig.scss';

const TimeEntityConfig = () => {
  return (
    <div className={styles.container}>
      <div className={styles.title}>How to use Time Type entity?</div>
      <div className={styles.subtitle}>
        Time entity can automatically detect the following things:
      </div>
      <div className={styles.group}>
        <div className={styles.head}>12 hour formats:</div>
        <div className={styles.row}>
          <div className={styles.key}>HH:MM am/pm</div>
          <div className={styles.value}>Eg: Remind me at 11:30am.</div>
        </div>
        <div className={styles.row}>
          <div className={styles.key}>H am/pm</div>
          <div className={styles.value}>Eg: Remind me at 4pm.</div>
        </div>
        <div className={styles.row}>
          <div className={styles.key}>H.MM am/pm</div>
          <div className={styles.value}>Eg: Remind me at 4.33 am.</div>
        </div>
      </div>
      <div className={styles.group}>
        <div className={styles.head}>24 hour formats:</div>
        <div className={styles.row}>
          <div className={styles.key}>HH:MM</div>
          <div className={styles.value}>Eg: Remind me at 11:30.</div>
        </div>
        <div className={styles.row}>
          <div className={styles.key}>HH</div>
          <div className={styles.value}>Eg: Remind me at 4.</div>
        </div>
      </div>
      <div className={styles.group}>
        <div className={styles.head}>Period of Time:</div>
        <div className={styles.row}>
          <div className={styles.key}>Morning</div>
          <div className={styles.value}>Eg: Send me jokes in morning.</div>
        </div>
        <div className={styles.row}>
          <div className={styles.key}>Afternoon</div>
          <div className={styles.value}>
            Eg: Remind me to order food this afternoon.
          </div>
        </div>
        <div className={styles.row}>
          <div className={styles.key}>Evening</div>
          <div className={styles.value}>
            Eg: Show me restaurants open this evening.
          </div>
        </div>
        <div className={styles.row}>
          <div className={styles.key}>Night</div>
          <div className={styles.value}>
            Eg: Remind me to go to movie tonight.
          </div>
        </div>
      </div>
      <div className={styles.group}>
        <div className={styles.head}>Time Range:</div>
        <div className={styles.row}>
          <div className={styles.key}>Before</div>
          <div className={styles.value}>Eg: Show me flights before 3PM</div>
        </div>
        <div className={styles.row}>
          <div className={styles.key}>After</div>
          <div className={styles.value}>Eg: Show me flights after 5:23AM.</div>
        </div>
      </div>
      <div className={styles.group}>
        <div className={styles.head}>Timezone Information:</div>
        <div className={styles.row}>
          <div className={styles.key}>
            User provides timezone information (“tz” : “America/Los_Angeles”)
          </div>
          <div className={styles.value}>
            Eg: Remind me to call John at 11:30 AM PST{' '}
          </div>
        </div>
      </div>

      <div className={styles.group}>
        <div className={styles.head}>A given time from the current time</div>
        <div className={styles.row}>
          <div className={styles.key}>After X time</div>
          <div className={styles.value}>
            Eg: Remind me to wakeup after 15 mins
          </div>
        </div>
        <div className={styles.row}>
          <div className={styles.key}>In X time</div>
          <div className={styles.value}>Eg: Call me back in 4 hours</div>
        </div>
        <div className={styles.row}>
          <div className={styles.key}>Interval</div>
          <div className={styles.value}>Eg: Ping me once in 1 week</div>
        </div>
      </div>
    </div>
  );
};

export default TimeEntityConfig;
